// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"ee5ea822","453":"c5735ed2","894":"f3de2832"}[chunkId] + ".chunk.js";
};